/**
 * Base URL for brand/static assets that do not change across app versions.
 * These are served from a dedicated CDN path.
 */
export const BRAND_ASSETS_BASE = 'https://static-app.mediainbox.io/app-brand';
